var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex } from "@rebass/grid";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { makeGetUnreadChatsCount } from "@rentiohq/shared-frontend/dist/reduxV2/chats/chat.selectors";
import React from "react";
import { useDropzone } from "react-dropzone";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DisplayText, Icon, Tabs, TextStyle } from "../../components";
import { ts } from "../../services";
import { showDropErrors } from "../../utils/file";
import { Button, ButtonActions } from "../Button";
import { DropdownMenu } from "../DropdownMenu";
import { ESpacings } from "../Grid";
import * as S from "./PageHeader.styled";
export var PageHeader = function (props) {
    var icon = props.icon, image = props.image, title = props.title, subtitle = props.subtitle, metadata = props.metadata, tabs = props.tabs, breadcrumbs = props.breadcrumbs, actions = props.actions, secondaryActions = props.secondaryActions, dropdown = props.dropdown, hasBorder = props.hasBorder, _a = props.fullWidth, fullWidth = _a === void 0 ? false : _a, onImageChange = props.onImageChange, _b = props.setDocumentTitle, setDocumentTitle = _b === void 0 ? true : _b, documentTitle = props.documentTitle;
    var navigate = useNavigate();
    var getUnreadChatsCount = makeGetUnreadChatsCount();
    var unreadChatsCount = useSelector(getUnreadChatsCount);
    React.useEffect(function () {
        if (!setDocumentTitle) {
            return;
        }
        var titleArray = [];
        if (unreadChatsCount > 0) {
            titleArray.push("(".concat(unreadChatsCount, ")"));
        }
        titleArray.push("Rentio");
        titleArray.push(documentTitle || title || "Dashboard");
        document.title = titleArray.join(" | ");
    }, [title, documentTitle, setDocumentTitle, unreadChatsCount]);
    // Event handlers
    var handlePressBreadcrumb = function () {
        if (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.goBack) {
            navigate(-1);
            return;
        }
        if (breadcrumbs === null || breadcrumbs === void 0 ? void 0 : breadcrumbs.to) {
            navigate(breadcrumbs.to);
            return;
        }
    };
    var handleDrop = function (acceptedFiles, fileRejections, event) {
        showDropErrors({ acceptedFiles: acceptedFiles, fileRejections: fileRejections, event: event });
        if (acceptedFiles.length === 0) {
            return;
        }
        onImageChange === null || onImageChange === void 0 ? void 0 : onImageChange(acceptedFiles[0]);
    };
    var _c = useDropzone({
        onDrop: handleDrop,
        multiple: false,
        maxSize: CONFIG.UPLOAD_MAX_FILE_SIZE,
        accept: "image/*",
    }), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps, isDragActive = _c.isDragActive;
    var dropzoneProps = __assign({}, getRootProps());
    var renderImageMarkup = function () {
        if (!image) {
            return null;
        }
        if (onImageChange) {
            return (_jsx(S.ImageWrapper, { children: _jsxs(S.ImageUploadWrapper, __assign({}, dropzoneProps, { isDragActive: isDragActive, children: [_jsx("input", __assign({}, getInputProps())), typeof image === "string" ? (_jsx("img", { alt: "", src: image })) : (_jsx(_Fragment, { children: image })), _jsxs(S.UploadIconWrapper, { children: [_jsx(Icon, { source: "camera", size: "large" }), ts.imageUpdate()] })] })) }));
        }
        return (_jsx(S.ImageWrapper, { children: typeof image === "string" ? _jsx("img", { alt: "", src: image }) : _jsx(_Fragment, { children: image }) }));
    };
    var iconMarkup = icon && !image ? (_jsx(S.IconWrapper, { children: _jsx(Icon, { source: icon, size: "large" }) })) : null;
    var dropdownMarkup = dropdown && dropdown.length > 0 ? (_jsx(DropdownMenu, { children: _jsx(Box, { ml: ESpacings.tight, children: _jsx(Icon, { source: "navigationMenuVertical" }) }), actions: dropdown })) : null;
    var titleMarkup = title ? (_jsxs(Flex, { alignItems: "center", children: [_jsx(DisplayText, { size: "extraLarge", element: "h1", space: "tight", children: title }), dropdownMarkup] })) : null;
    var subtitleMarkup = subtitle ? _jsx(S.SubTitle, { children: subtitle }) : null;
    var metadataMarkup = metadata ? (_jsx(TextStyle, { variation: "subdued", children: metadata })) : null;
    var breadcrumbsMarkup = breadcrumbs ? (_jsx(S.Breadcrumbs, { children: _jsx(Button, { appearance: "link", onClick: handlePressBreadcrumb, children: "\u2039 ".concat(breadcrumbs.content) }) })) : null;
    var tabsMarkup = tabs ? (_jsx(S.Tabs, { children: _jsx(Tabs, { tabs: tabs }) })) : null;
    var actionsMarkup = actions && actions.length > 0 ? (_jsx(S.Actions, { children: _jsx(ButtonActions, { actions: actions, options: {
                overrides: {
                    appearance: "primary",
                },
            } }) })) : null;
    var secondaryActionsMarkup = secondaryActions ? (_jsx(DropdownMenu, { children: _jsx(Button, { appearance: "add", color: "primary", children: _jsx(Icon, { source: "add", size: "large" }) }), actions: secondaryActions })) : null;
    var hasTabs = !!tabs;
    return (_jsx(S.Wrapper, { fullWidth: fullWidth, children: _jsxs(S.Container, { hasBorder: hasBorder, hasTabs: hasTabs, children: [_jsxs(S.Content, { children: [breadcrumbsMarkup, _jsxs(Flex, { alignItems: "center", children: [renderImageMarkup(), iconMarkup, _jsxs(S.ContentMain, { children: [subtitleMarkup, titleMarkup, metadataMarkup] }), _jsxs(S.ContentAside, { children: [actionsMarkup, secondaryActionsMarkup] })] })] }), tabsMarkup] }) }));
};
